import { baseApi } from 'components/constants/Constants';
import { useAxiosWithAuth } from '../useAxios';
import { ContentPost, UXBContentCategory } from 'portals/types';
import { ContentPage } from 'types/global';

export const useGetContentPosts = <T>(
  portalKey: string,
  contentType: UXBContentCategory
) =>
  useAxiosWithAuth<{
    content: ContentPost<T>[];
    page: ContentPage;
  }>(
    {
      url: `${baseApi}/portals/${portalKey}/contents/${contentType}/posts`,
      method: 'GET'
    },
    {
      manual: true
    }
  );

export const useGetContentPost = <T>(
  portalKey: string,
  contentType: UXBContentCategory,
  id: string
) =>
  useAxiosWithAuth<ContentPost<T>>(
    {
      url: `${baseApi}/portals/${portalKey}/contents/${contentType}/posts/${id}`,
      method: 'GET'
    },
    {
      manual: true
    }
  );

export const usePostContentPosts = (
  portalKey: string,
  contentType: UXBContentCategory
) =>
  useAxiosWithAuth<null, FormData>(
    {
      url: `${baseApi}/portals/${portalKey}/contents/${contentType}/posts`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' }
    },

    {
      manual: true
    }
  );

export const usePatchContentPost = (
  portalKey: string,
  contentType: UXBContentCategory
) => {
  const [, execute] = useAxiosWithAuth<null, FormData>(
    {
      method: 'PATCH',
      url: '',
      headers: { 'Content-Type': 'multipart/form-data' }
    },
    { manual: true }
  );

  const patchPost = (data: FormData, postId: string) => {
    return execute({
      url: `${baseApi}/portals/${portalKey}/contents/${contentType}/posts/${postId}`,
      data: data
    });
  };

  return { patchPost };
};

export const useDeleteContentPost = (
  portalKey: string,
  contentType: UXBContentCategory
) => {
  const [, execute] = useAxiosWithAuth<null, string>(
    {
      method: 'DELETE',
      url: ''
    },
    { manual: true }
  );

  const deletePost = (postId: string) => {
    return execute({
      url: `${baseApi}/portals/${portalKey}/contents/${contentType}/posts/${postId}`
    });
  };

  return { deletePost };
};
